export const useBtn = (
  mode: string,
  rounded: boolean,
  uppercase: boolean,
  customParams: any
) => {
  /**
   * Ontienen las clases por defecto segun el modo
   * @author   ehernandez --> nombre del creador
   * @param    {boolean} disabled
   * @return   {string}
   */
  const classFromMode = (disabled: boolean) => {
    let classes =
      'tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-3 tw-w-full '
    switch (mode) {
      case 'primary':
        classes += `tw-bg-brand ${!disabled ? 'tw-bg-brand hover:tw-bg-brandMedium' : 'tw-bg-brandSoft'} tw-text-white`
        break

      case 'secondary':
        classes += 'tw-bg-black tw-opacity-10 tw-text-brand'
        break

      case 'custom':
        classes += `tw-bg-${customParams?.bg || 'brand'} ${customParams?.border
          ? `tw-border tw-border-${customParams.border}`
          : ''
          } ${!disabled &&
          `hover:tw-opacity-90 ${customParams?.border
            ? `hover:tw-bg-${customParams?.border} hover:tw-text-white`
            : ''
          }`
          } tw-text-${customParams?.text || 'white'}`
        // console.log(classes);
        break

      case 'aggridSeconday':
        classes += `tw-bg-secondary ${!disabled && 'hover:tw-opacity-90'
          } tw-text-white`
        break

      case 'aggridTransparentSecondary':
        classes += `tw-bg-transparent ${!disabled && 'hover:tw-bg-secondary hover:tw-text-white'
          } tw-text-secondary tw-border-2 tw-border-secondary`
        break

      case 'transparent':
        classes += `tw-bg-transparent ${!disabled && 'hover:tw-bg-brandMedium hover:tw-text-white'
          } tw-text-brand tw-border-2 tw-border-brand`
        break

      case 'expansible':
        classes +=
          'tw-bg-transparent tw-text-brand tw-border-l tw-border-t tw-border-r tw-border-brand tw-text-secondary expansible'
        break

      case 'custom-expansible':
        classes += `tw-bg-transparent tw-text-${customParams?.text || 'brand'
          } tw-border-l tw-border-t tw-border-r tw-border-${customParams?.border || 'brand'
          } expansible`
        break

      default:
        break
    }

    if (rounded) {
      classes += ' tw-rounded-full'
    }

    if (disabled) {
      classes += ' tw-bg-opacity-50'
    }

    if (uppercase) {
      classes += ' tw-uppercase'
    }

    return classes
  }

  return { classFromMode }
}
